const state = {
    quotes:[],
    quoteitems:[]

}

const getters = {
    quotes: state => state.quotes,
    quoteitems: state => state.quoteitems,

}

const actions = {
    newQuotes({commit},payload){
        let quotekey = firebase.database().ref('quotes').push().getKey()
        payload.quotes.forEach(item=>{
            item.quoteid=quotekey
            firebase.database().ref('quoteitems').push(item)
        })
        console.log(payload)
        firebase.database().ref('quotes').child(quotekey).set(payload.new_quote)
        .then(()=>{
            commit("setNotifications",{message:'Quote created successfully',type:'success'})
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })


    },
    // LOGIN REGISTERED USER
    fetchQuotes({commit},payload){
        firebase.database().ref('quotes').on('value', snapshot => {
            commit('setAllQuotes', snapshot.val())
        })
    },
    fetchQuoteItems({commit},payload){
        firebase.database().ref('quoteitems').on('value', snapshot => {
            commit('setQuoteItems', snapshot.val())
        })
    },

 
}

const mutations = {
    setAllQuotes: (state, payload) => {
        let quotes_Array=[]
        for(let key in payload) {
            payload[key].id=key
            quotes_Array.push(payload[key])
        }
        state.quotes=quotes_Array
    },
    setQuoteItems: (state, payload) => {
        let quotes_Array=[]
        for(let key in payload) {
            payload[key].id=key
            quotes_Array.push(payload[key])
        }
        state.quoteitems=quotes_Array
    },

    
   
}

export default {
    state,
    actions,
    getters,
    mutations
}